<template>
  <div>
    <div class="container-pay">
      <!-- 面包屑 -->
      <el-breadcrumb separator="/" style="line-height: 40px">
        <el-breadcrumb-item :to="{ name: 'basicInfo' }"
          >个人中心</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ name: 'orderList' }"
          >我的订单</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div>
        <div class="my-steps">
          <el-steps :active="2" finish-status="success">
            <el-step title="购物/询价"></el-step>
            <el-step title="提交订单"></el-step>
            <el-step title="完成"></el-step>
          </el-steps>
        </div>
        <div class="info">
          <div class="info-cont">
            <div class="info-cont-left">
              <h2>
                <i class="el-icon-success"></i>
                订单已提交成功，请您及时付款，我们将尽快为您安排发货！
              </h2>
              <div class="order-info">
                <span>订单编号： {{ orderCode }}</span
                ><span
                  >订单金额：
                  <b>￥ {{ payMoney | formatePrice }}</b></span
                >
              </div>
              <div class="btns">
                <a href="/">继续购物</a
                ><a :href="`/order/orderDetail/${orderId}`">查看订单</a>
              </div>
            </div>
            <div class="info-cont-right">
              <div><b>注意事项</b>（转账必读）</div>
              <p>
                1,公司转账汇款时请将订单编号【{{ orderCode }}】填写
                至汇款单中“用途备注/摘要”等栏；
              </p>
              <p>
                2,下单后请尽快转账，务必保证转账金额与订单金额一致，
                请勿多转/少转或分次转账，否则影响订单对账进度，如未及
                时汇款，订单将在下单15天后自动取消；
              </p>
              <p>
                3,如存在个人汇款、第三方代汇款等情况，还需提供对应的
                代付委托声明：代付证明加盖公章后请联系在线客服或拨谢打
                客服热线400-887-6000提交。
              </p>
            </div>
          </div>
        </div>
        <div class="tip">
          <div class="tip-title">
            线下转账信息
            <span
              >（<b>温馨提示</b>：请按照以下信息进行线下转账汇款操作）</span
            >
          </div>
          <el-table :data="tableData" border style="width: 100%">
            <el-table-column width="300px" prop="label" label="银行账号信息">
            </el-table-column>
            <el-table-column prop="value" label=""> </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    payMoney () {
      return this.$route.query.money
    }
  },
  data () {
    return {
      orderCode: '',
      orderId: '',
      tableData: [
        {
          label: '公司名称',
          value: '浙江工自仪网络有限公司'
        },
        {
          label: '银行账号',
          value: '1202023419100041747'
        },
        {
          label: '开户银行',
          value: '中国工商银行股份有限公司杭州景江苑支行'
        },
        {
          label: '银行联行号',
          value: '102331002340'
        },
        {
          label: '用途/备注/摘要',
          value: '官网订单号'
        },
        {
          label: '税号',
          value: '91330108MA2HXKC15N'
        },
        {
          label: '电话',
          value: '400-887-6000'
        },
        {
          label: '地址',
          value: '浙江省杭州市富阳区东洲街道高尔夫路209号第2幢307室'
        }
      ]
    }
  },
  created () {
    this.getInfo()
  },
  methods: {
    // 查询订单详情
    getInfo () {
      this.orderId = this.$route.query.id
      if (!this.orderId) {
        return false
      }
      this.goodsPage = 1
      this.$request.get(`/front/consumer/shopping/order/orderInfo/${this.orderId}/false/1/10`)
        .then((res) => {
          this.orderCode = res.orderCode
        })
        .catch(() => {
          this.orderDetail = null
        })
    }
  }
}
</script>
<style scoped lang="scss">
.container-pay {
  width: 1190px;
  margin: 0 auto;
  .pay-dialog-tip {
    display: flex;
    margin-top: 10px;
    justify-content: space-between;
    // align-items: center;
    font-size: 14px;
    line-height: 26px;
    .pay-tip-title {
      flex-shrink: 0;
      width: 80px;
    }
    .pay-tip-content {
      flex-grow: 1;
      color: #ff9238;
    }
  }
}
.body-info {
  margin: 20px 0;
  width: 100%;
  padding: 30px 0;
  background-color: #fff;
  word-wrap: break-word;
  word-break: break-all;
}

.my-steps {
  padding: 30px 20%;
}

.container-pay .info {
  padding: 20px 0;
}

.container-pay .info-cont {
  display: flex;
  background-color: #F0F8FF;
  padding: 30px 20px;
  border-radius: 2px;
}

.container-pay .info-cont-left {
  flex-basis: 720px;
  font-size: 14px;
}

.container-pay .info-cont-left h2 {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #67C23A;
  line-height: 32px;
  margin: 0;
  font-weight: 700;
}

.info-cont-left .el-icon-success {
  margin-right: 12px;
  font-size: 32px;
}

.container-pay .info-cont-left .order-info {
  margin-top: 30px;
}

.container-pay .info-cont-left .order-info span:last-child {
  margin-left: 24px;
}

.container-pay .info-cont-left .order-info b {
  color: #e93037;
}

.container-pay .info-cont-left .btns {
  margin-top: 30px;
  text-align: center;
}

.container-pay .info-cont-left .btns a {
  display: inline-block;
  width: 88px;
  height: 34px;
  line-height: 34px;
  color: #fff;
  background-color: #2a54d1;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #2a54d1;
  text-align: center;
  text-decoration: none;
  &:hover {
    opacity: 0.8;
  }
}

.container-pay .info-cont-left .btns a:last-child {
  color: #2a54d1;
  background-color: #fff;
  margin-left: 30px;
}

.container-pay .info-cont-right {
  flex: 1 1;
  text-align: left;
  padding-left: 30px;
  border-left: 1px solid #fff;
  color: #333;
  font-size: 12px;
}

.container-pay .info-cont-right div {
  line-height: 20px;
}

.container-pay .info-cont-right p {
  padding-top: 8px;
  line-height: 20px;
}

.container-pay .info-cont-right p span {
  text-decoration: underline;
  cursor: pointer;
  color: #369;
}

.container-pay .tip-title {
  color: #333;
  font-size: 16px;
  padding-bottom: 24px;
}
</style>
